export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6248.d2ceff62.jpg";